<template>

<div>

    <select-winner v-if='!projectPhase.user_id'></select-winner>

    <div v-if='projectPhase.user_id'>
        
        <auction-winner v-if='phase.type == "auction"'></auction-winner> 
        <select-winner v-if='phase.type == "competition"'></select-winner>           

    </div>

</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
            if ( typeof this.pp == 'object' ) {
                this.projectPhase = this.pp;
            }
        },

        props : ['pp'],

        data() {

            return {

                phase        : this.$parent.$parent.phase,
                projectPhase : this.$parent.$parent.projectPhase,
                project      : this.$parent.$parent.model

            }

        },

        methods : {

        },

        components : {
            'select-winner'         : require('./SelectWinner.vue').default,
            'auction-winner'        : require('./AuctionWinner.vue').default,
            'competition-winner'    : require('./CompetitionWinner.vue').default
        }

    }
</script>
